package com.artvending.warden

import kotlinx.coroutines.CompletableDeferred


class Action<T> {
	private var result: T? = null
	private val deferred = CompletableDeferred<Unit>()
	
	fun release(result: T? = null) {
		this.result = result
		deferred.complete(Unit)
	}
	
	
	operator fun invoke(result: T? = null) {
		release(result)
	}
	
	
	suspend fun launch(block: suspend () -> Unit): T? {
		block.invoke()
		deferred.await()
		return result
	}
}


suspend fun <T> action(block: suspend (action: Action<T>) -> Unit): T? {
	val activity = Action<T>()
	
	return activity.launch {
		block(activity)
	}
}